export default {
  DashboardPage: {
    dashboard: 'Dashboard',
    donorDashboard: 'Donor Dashboard',
    donationDashboard: 'Donation Dashboard',
    ownerDashboard: 'Owner Dashboard',
  },
  DashboardTabs: {
    donors: 'Donors',
    donations: 'Donations',
    owners: 'Owners',
  },
  DonorDashboard: {
    donorDashboardTitle: 'Donor Dashboard',
    donorDashboardDescription: 'Overview of donor statistics and metrics',
    loading: 'Loading...',
    errorLoading: 'Error loading data: {{message}}',
    noDataAvailable: 'No data available',
    noDataDescription:
      'Please ensure the analytics service is running and try refreshing the page.',
    clickToViewDonors:
      'Click on a status card above to view donors with that status',
    recentDonors: 'Recent Donors',
    donors: 'Donors',
    donorTypesDistribution: 'Donor Types Distribution',
    statusBreakdown: 'Status Breakdown',
    activeDonors: 'Active Donors',
    singleDonors: 'Single Donors',
    doubleDonors: 'Double Donors',
    newDonors: 'New Donors',
    experiencedDonors: 'Experienced Donors',
    activeStatus: 'Active',
    pendingStatus: 'Pending',
    approvedStatus: 'Approved',
    archivedStatus: 'Archived',
    notAcceptedStatus: 'Not Accepted',
    trpStatus: 'TRP',
    retiredStatus: 'Retired',
    affiliateStatus: 'Affiliate',
    RegionFilter: {
      region: 'Region:',
      selectRegion: 'Select region',
      allRegions: 'All Regions',
    },
    DonorTable: {
      name: 'Name',
      age: 'Age',
      gender: 'Gender',
      species: 'Species',
      weight: 'Weight',
      bloodType: 'Blood Type',
      approvedML: 'Approved ML',
      location: 'Location',
      status: 'Status',
      unknown: 'Unknown',
      years: '{{value}} yrs',
      pounds: '{{value}} lbs',
      milliliters: '{{value}} ml',
    },
    DonationsModal: {
      title: 'Donations for {{donorName}}',
      defaultTitle: 'Donor Donations',
      close: 'Close',
      date: 'Date',
      location: 'Location',
      region: 'Region',
      bloodType: 'Blood Type',
      collectionSet: 'Collection Set',
      collectedMl: 'Collected (ml)',
      approvedMl: 'Approved (ml)',
      outcome: 'Outcome',
      veterinarian: 'Veterinarian',
      capillaryRefill: 'Capillary Refill',
      unknown: 'Unknown',
      na: 'N/A',
      milliliters: '{{value}} ml',
    },
  },
  DonationDashboard: {
    donationDashboardTitle: 'Donation Dashboard',
    donationDashboardDescription: 'Overview of donation statistics and metrics',
  },
  OwnerDashboard: {
    ownerDashboardTitle: 'Owner Dashboard',
    ownerDashboardDescription: 'Overview of owner statistics and metrics',
  },
  RecruiterDashboard: {
    title: 'Recruiter Dashboard',
    tabDashboard: 'Dashboard',
    tabDonorDetails: 'Donor Details',
    tabLeaderboard: "Recruiters' Leaderboard",
    dashboardTitle: 'Recruiter Dashboard',
    dashboardDescription: 'Overview of recruiter performance and metrics.',
    donorDetailsTitle: 'Donor Details',
    donorDetailsDescription:
      'Detailed donor information and metrics for recruiters.',
    filtersDateRange: 'Date Range',
    filtersRegion: 'Region',
    filtersOffice: 'Office',
    filtersLocation: 'Location',
    filtersAllRegions: 'All Regions',
    filtersAllOffices: 'All Offices',
    filtersAllLocations: 'All Locations',

    simulation: {
      active: 'Simulation Active:',
      viewingAs: 'Viewing as',
      asUser: 'as user',
      officeLabel: '(Office: {{name}})',
      configureInSettings: '— Configure in Settings',
    },

    viewOptions: {
      header: 'Visibility / Default Options',
      defaultDateRange: 'Default Date Range:',
      optionLabels: {
        recruitmentGoals: 'Recruitment Goals (Period)',
        recruiterStats: 'Recruiter Stats',
        quarterlyGoal: 'Quarterly Goal',
        donorPipelineStrip: 'Donor Pipeline Metrics Strip',
        newRegistrationsChart: 'New Registrations Chart',
        donorChurnRate: 'Donor Churn Rate',
        showRatesDblUnit: 'Show-rates / Dbl Unit Donors',
        retiredDonors: 'Retired Donors (Unresponsive)',
        lapsedDonors: 'Lapsed Donors Needing Outreach',
      },
      dateRangeGroups: {
        rolling: '— Rolling —',
        calendar: '— Calendar —',
      },
      dateRangeOptionLabels: {
        day: 'Today',
        yesterday: 'Yesterday',
        week: 'Week',
        lastWeek: 'Last Week',
        month: 'Month',
        lastMonth: 'Last Month',
        quarter: 'Quarter',
        lastQuarter: 'Last Quarter',
        year: 'Year',
        lastYear: 'Last Year',
        dayCal: 'Today',
        yesterdayCal: 'Yesterday',
        weekCal: 'This Week',
        lastWeekCal: 'Last Week',
        monthCal: 'This Month',
        lastMonthCal: 'Last Month',
        quarterCal: 'This Quarter',
        lastQuarterCal: 'Last Quarter',
        yearCal: 'This Year',
        pYearCal: 'Last Year',
      },
    },

    goalCard: {
      periodTitle: '{{dateRangeLabel}} Products Created',
      prbcCollected: 'pRBC Collected',
      ffpCollected: 'FFP Collected',
      ffpUnitsTooltip:
        'View individual FFP product units created in this period — one row per unit with donor, owner, location, and region details',
      prbcGoal: 'pRBC Goal',
      goalTooltipPeriod:
        'Goal = daily pRBC target ({{dailyTarget}}) × working days in period ({{workingDays}}) × offices counted ({{officeCount}})',
      statusTooltipPeriod:
        '"{{statusLabel}}" means your current collection pace relative to the daily goal is {{pacePercent}}%. Status is based on pace, not raw progress — it accounts for how many working days have elapsed.',
      dailyPaceLabel: 'Daily pace needed to hit goal ({{dateRangeLabel}}):',
      prbcUnitsTooltip:
        'View individual pRBC product units created in this period — one row per unit with donor, owner, location, and region details',
      quarterlyTitle: 'Quarterly Products Created',
      quarterlyGoal: 'Quarterly goal',
      goalTooltipQuarterly:
        'Goal = daily pRBC target ({{dailyTarget}}) × working days in quarter ({{workingDays}}) × offices counted ({{officeCount}})',
      statusTooltipQuarterly:
        '"{{statusLabel}}" means your current quarterly collection pace relative to the daily goal is {{pacePercent}}%. Status is based on pace, not raw progress — it accounts for how many working days have elapsed.',
      prbcUnitsQuarterlyTooltip:
        'View individual pRBC product units created this quarter — one row per unit with donor, owner, location, and region details',
      footerAllOffices: 'Across all offices',
      footerOffice_one: 'Office: {{names}}',
      footerOffice_other: 'Offices: {{names}}',
      footerRegion_one: 'Region: {{names}}',
      footerRegion_other: 'Regions: {{names}}',
    },

    pipeline: {
      sectionTitle: 'Donor Pipeline Health Summary',
      totalActiveDonors: 'Total Active Donors:',
      activeDonorsTooltip: 'Show Active Donors list in Donor Details tab',
      totalPendingDonors: 'Total Pending Donors:',
      pendingDonorsTooltip: 'Show Pending Donors list in Donor Details tab',
      totalApprovedDonors: 'Total Approved Donors:',
      approvedDonorsTooltip: 'Show Approved Donors list in Donor Details tab',
      retentionScoreLabel: 'Program Retention Score:',
      retentionDetailsLabel: 'Retention Details',
      retentionDetailsTooltip: 'View retention score breakdown and history',
      dropoutRateLabel: 'Quarterly Dropout Rate:',
      dropoutDetailsLabel: 'Dropout Details',
      dropoutDetailsTooltip: 'View dropout rate breakdown and history',
      ratioLabel: 'First-Time vs. Repeat Ratio:',
      ratioDetailsLabel: 'Ratio Details',
      ratioDetailsTooltip:
        'View first-time vs. repeat ratio breakdown and history',
      donorListLabel: 'Donor List',
    },

    churnCard: {
      title: 'Donor Churn Rate',
      detailsLabel: 'Churn Details',
      detailsTooltip: 'View churn rate breakdown and formula',
      currentPeriodLabel: 'Current Churn Rate ({{dateRangeLabel}})',
      quarterlyLabel: 'Churn Rate (This Quarter)',
    },

    showRatesCard: {
      title: 'Donor Show-rates / Dbl Unit Donors',
      showRateLabel: 'Donor Show-rate %',
      detailsLabel: 'Show Rate Details',
      detailsTooltip: 'View show rate breakdown and history',
      dblSglLabel: 'Dbl/Sgl Unit Donors',
      singleDonorsLabel: 'Single Donors',
      singleDonorsTooltip: 'Show Single Donors list in Donor Details tab',
      doubleDonorsLabel: 'Double Donors',
      doubleDonorsTooltip: 'Show Double Donors list in Donor Details tab',
      donorListLabel: 'Donor List',
    },

    newRegistrations: {
      title: 'New Registrations by Period (Scaled)',
      rolling: 'Rolling',
      calendar: 'Calendar',
      loading: 'Loading...',
      todayLabel: "Today's",
      yesterdayLabel: "Yesterday's",
      clickTooltip:
        'Show list of new Donors from {{yesterdayLabel}} in the Donor Details tab',
      barLabels: {
        rolling: {
          week: 'Week',
          month: 'Month',
          quarter: 'Quarter',
          year: 'Year',
        },
        calendar: {
          week: 'This Week',
          month: 'This Month',
          quarter: 'This Quarter',
          year: 'This Year',
        },
      },
      barTooltips: {
        week: {
          rolling:
            'Rolling: last 7 days from today. Scaled to annual rate (×52). Click to view donors.',
          calendar:
            'Calendar: current calendar week (Mon–Sun). Scaled to annual rate (×52). Click to view donors.',
        },
        month: {
          rolling:
            'Rolling: last 30 days from today. Scaled to annual rate (×12). Click to view donors.',
          calendar:
            'Calendar: current calendar month (1st–last day). Scaled to annual rate (×12). Click to view donors.',
        },
        quarter: {
          rolling:
            'Rolling: last 90 days from today. Scaled to annual rate (×4). Click to view donors.',
          calendar:
            'Calendar: current calendar quarter. Scaled to annual rate (×4). Click to view donors.',
        },
        year: {
          rolling:
            'Rolling: last 365 days from today. Actual count (no scaling). Click to view donors.',
          calendar:
            'Calendar: current calendar year (Jan 1–Dec 31). Actual count (no scaling). Click to view donors.',
        },
      },
    },

    donorRangeCard: {
      daysLabel: 'Days',
      donorListLabel: 'Donor List',
      retiredTooltip:
        'Show Retired Donors ({{label}} Days) in Donor Details tab',
      lapsedTooltip: 'Show Lapsed Donors (>{{bp}} Days) in Donor Details tab',
    },

    historyChart: {
      noData: 'No historical data available',
      cutoffNote:
        'History shown from {{date}} — donor status change tracking began on this date.',
    },

    donorRange: {
      retired: 'Retired Donors (Unresponsive)',
      lapsed: 'Lapsed Donors Needing Outreach',
      recent: 'Recent',
      moderate: 'Moderate',
      extended: 'Extended',
      critical: 'Critical',
    },

    churnModal: {
      title: 'Donor Churn Rate — Details',
      tooltipDropouts: 'Dropouts: {{value}}',
      tooltipEnrollments: 'Enrollments: {{value}}',
      tooltipActiveAtStart: 'Active at start: {{value}}',
      tooltip:
        'Churn rate measures net donor attrition: donors lost minus new donors gained, as a percentage of the starting active pool. A negative rate means net growth.',
      explainerDropoutTerm: 'Dropout:',
      explainerDropoutDef:
        'a donor whose status changed from an active status ({{statuses}}) to an inactive status during the period.',
      explainerTransientTerm: 'Transient donors',
      explainerTransientDesc:
        '(enrolled and dropped in the same period) are excluded from both counts. A',
      explainerNegativeTerm: 'negative churn rate',
      explainerNegativeDesc: 'indicates net donor growth.',
      sectionCurrentPeriod: 'Current Period',
      sectionThisQuarter: 'This Quarter',
      statActiveAtStart: 'Active donors at start of period',
      statDropouts: 'Dropouts (active → inactive)',
      statEnrollments: 'New enrollments (inactive → active)',
      statNetChange: 'Net donor change',
      formula: '(Dropouts − Enrollments) ÷ Active-at-Start × 100',
      historyTitle: 'Historical Churn — {{periodLabel}}',
      legendGood: '● Good (<{{value}}%)',
      legendOk: '● OK ({{low}}–{{high}}%)',
      legendPoor: '● Poor (>{{value}}%)',
    },

    dropoutModal: {
      title: 'Quarterly Dropout Rate — Details',
      tooltipDropouts: 'Dropouts: {{value}}',
      tooltipActiveAtStart: 'Active at start: {{value}}',
      tooltip:
        'Dropout Rate = Donors who left ÷ Active Donors at Start × 100. Dropout: a donor whose status changed from an active status ({{statuses}}) to a non-active status.',
      explainerTerm: 'Dropout Rate',
      explainerDef:
        'measures what percentage of active donors at the start of the quarter became inactive by end of quarter. Unlike Churn Rate, this metric does not account for new enrollments — it focuses purely on attrition.',
      explainerStatusChange:
        'Dropout: status changed from ({{statuses}}) to a non-active status.',
      sectionThisQuarter: 'This Quarter',
      statActiveAtStart: 'Active donors at start of quarter',
      statDropouts: 'Donors who dropped out',
      formula: 'Dropouts ÷ Active-at-Start × 100',
      historyTitle: 'Dropout Rate History — Last 4 Quarters',
      legendGood: '● Good (<{{value}}%)',
      legendOk: '● OK ({{low}}–{{high}}%)',
      legendPoor: '● Poor (>{{value}}%)',
    },

    retentionModal: {
      title: 'Program Retention Score — Details',
      tooltipRepeat: 'Repeat: {{value}}',
      tooltipActive: 'Active: {{value}}',
      tooltip:
        'Retention score = Repeat Donors ÷ Active Donors × 100. A higher score means more donors are returning to donate multiple times.',
      explainerTerm: 'Retention Score',
      explainerDef:
        'measures what percentage of active donors are repeat donors (have donated at least the configured threshold number of times). A higher score means more donors are returning.',
      explainerActiveStatuses: 'Active statuses: {{statuses}}',
      sectionCurrentPeriod: 'Current Period',
      statTotalActive: 'Total active donors',
      statRepeatDonors: 'Repeat donors (≥ threshold donations)',
      statFirstTimeDonors: 'First-time donors',
      formula: 'Repeat Donors ÷ Active Donors × 100',
      thresholdLow: 'Needs Attention',
      thresholdMid: 'OK',
      thresholdHigh: 'Excellent',
      historyTitle: 'Retention Score History — {{periodLabel}}',
      legendGood: '● Good (≥{{value}}%)',
      legendOk: '● OK ({{low}}–{{high}}%)',
      legendPoor: '● Poor (<{{value}}%)',
    },

    ratioModal: {
      title: 'First-Time vs. Repeat Ratio — Details',
      tooltipFirstTime: 'First-time: {{value}}',
      tooltipRepeat: 'Repeat: {{value}}',
      tooltipActiveTotal: 'Active total: {{value}}',
      formulaFirstTimePct: 'First-time % =',
      tooltip:
        'The ratio compares first-time donors (< threshold donations) to repeat donors (≥ threshold donations) among all currently active donors ({{statuses}}).',
      explainerTitle: 'First-Time vs. Repeat',
      explainerDef:
        'shows the balance between newly enrolled donors and experienced repeat donors. The ratio is GCD-reduced (e.g. 30 : 60 → 1 : 2). A high repeat proportion indicates strong program loyalty.',
      sectionCurrentPeriod: 'Current Period',
      statTotalActive: 'Total active donors',
      statFirstTimeDonors: 'First-time donors',
      statRepeatDonors: 'Repeat donors',
      formulaBoxTitle: 'How the ratio is calculated',
      formulaCandidates: 'Candidate ratios (dividend / pct = divisor):',
      formulaNote:
        "Pick lowest rounding error. If 1/2/3 is within 0.1 of 5's error, favor 1/2/3.",
      formulaResultLabel: 'Result:',
      historyTitle: 'First-Time Donor % History — {{periodLabel}}',
      legendGood: '● Good (<33% first-time)',
      legendOk: '● OK (33–66%)',
      legendPoor: '● Poor (>66% first-time)',
    },

    showRateModal: {
      title: 'Donor Show-Rate — Details',
      tooltipDonated: 'Came: {{value}}',
      tooltipExpected: 'Expected: {{value}}',
      tooltip:
        'Show Rate = Expected Donors Who Came ÷ Expected Donors × 100, counted per donation day. A donor is expected when they belong to the location, their status on the day was {{statuses}} or Approved, and they were due by their own donation frequency. Came = a donation (eligible or deferred), a DVM exam or a lab draw that day.',
      explainerTerm: 'Show Rate',
      explainerDef:
        'measures the share of donors expected on each donation day who actually came, whether they donated, were deferred at screening, or had a DVM exam or lab draw. A higher show rate means expected donors are showing up.',
      sectionCurrentPeriod: 'Current Period',
      statDonationsGiven: 'Expected donors who came',
      statExpected: 'Expected donors',
      formula: 'Expected Donors Who Came ÷ Expected Donors × 100',
      thresholdLow: 'Poor',
      thresholdMid: 'OK',
      thresholdHigh: 'Good',
      historyTitle: 'Show Rate History — {{periodLabel}}',
      legendPoor: '● Poor (<{{value}}%)',
      legendOk: '● OK ({{low}}–{{high}}%)',
      legendGood: '● Good (>{{value}}%)',
    },

    modals: {
      currentPeriodLabel: 'Current Period ({{dateRangeLabel}})',
      thisQuarterLabel: 'This Quarter',
      statusLabels: {
        good: 'Good',
        ok: 'OK',
        poor: 'Poor',
        needsAttention: 'Needs Attention',
        excellent: 'Excellent',
      },
    },
  },
  OperationsDashboard: {
    title: 'Operations Dashboard',
    tabOverview: 'Overview',
    tabPhlebotomist: 'Phlebotomist',
    tabRecruiter: 'Recruiter',
    tabHandler: 'Handler',
    tabDrilldown: 'Drilldown',
    tabTrends: 'Trends',
    tabPaws: 'PAWS',
    placeholderTitle: 'Coming Soon',
    placeholderDescription: 'This tab is under development.',
  },
  PhlebotomistDashboard: {
    title: 'Phlebotomist Dashboard',
    description: 'Tools and information for phlebotomy collection team members',

    // Filters
    filters: {
      dateRange: 'Date Range',
      region: 'Region',
      phlebotomist: 'Phlebotomist',
      showRegion: 'Show Region Comparison',
      showCompany: 'Show Company Comparison',
      allRegions: 'All Regions',
      allPhlebotomists: 'All Phlebotomists',
      selectRegions: 'Select regions...',
      selectPhlebotomist: 'Select phlebotomist...',
    },

    // Date range options
    dateRanges: {
      day: 'Today',
      week: 'This Week',
      month: 'This Month',
      quarter: 'This Quarter',
      ytd: 'Year to Date',
      year: 'This Year',
      custom: 'Custom Range',
    },

    // Cards
    cards: {
      attempted: {
        title: 'Attempted Donations',
        singleDonors: 'SGL Donors',
        doubleDonors: 'DBL Donors',
      },
      productYield: {
        title: 'Product Yield',
        expected: 'Expected',
        actual: 'Actual',
        total: 'Total',
        prbc: 'pRBC',
        ffpSingle: 'FFP Single',
        ffpDouble: 'FFP Double',
        dblDonorsSglYield: 'DBL Donors, SGL Yield',
      },
      successRate: {
        title: 'Success Rates',
        overall: 'Overall',
        prbc: 'pRBC',
        sglDonors: 'SGL Donors',
        dblDonors: 'DBL Donors',
      },
      comparison: {
        title: 'Comparison Metrics',
        yourStats: 'Your Stats',
        office: 'Office',
        region: 'Region',
        company: 'Company',
        overall: '— Overall —',
        prbcOnly: '— pRBC Only —',
        success: 'Success',
        attempted: 'Attempted',
        expected: 'Expected',
        actual: 'Actual',
      },
    },

    // Table
    table: {
      title: 'Recent Donations/Draws',
      date: 'Date',
      donor: 'Donor',
      type: 'Type',
      approvedML: 'Approved (mL)',
      expectedPRBC: 'Exp pRBC',
      expectedFFPS: 'Exp FFP-S',
      expectedFFPD: 'Exp FFP-D',
      actualPRBC: 'Act pRBC',
      actualFFPS: 'Act FFP-S',
      actualFFPD: 'Act FFP-D',
      status: 'Status',
      pagination: '{{start}}-{{end}} of {{total}} items',
      single: 'Single',
      double: 'Double',
      statusComplete: 'Complete',
      statusDblToSgl: 'DBL→SGL',
      statusIneligible: 'Ineligible',
      statusPartial: 'Partial',
    },
  },
};
